import type { FunctionComponent, ReactNode } from 'react'
import React from 'react'
import { AccordionItem as SBAccordionItem } from '@which/seatbelt'

export const AccordionItem: FunctionComponent<Props> = ({ children, label, id }) => (
  <SBAccordionItem key={id} content={children} label={label} />
)

///////// IMPLEMENTATION /////////

type Props = {
  children: ReactNode
  label: string
  id: string
}
